import Button from '../Button/Button'

const Modal = ({ handleClose, message }) => {
  return (
    <div className='fixed inset-0 z-[1000] flex items-center justify-center bg-black/50 px-4'>
      <div className='w-full max-w-[500px] rounded-lg bg-white p-5'>
        <div className='flex items-center justify-between'>
          <h5 className='m-0 text-xl font-medium'>Message sent</h5>
          <button
            type='button'
            className='border-0 bg-transparent text-2xl leading-none text-neutral-brand'
            onClick={handleClose}
            aria-label='Close message'
          >
            &times;
          </button>
        </div>
        <div className='my-2.5 [&_p:not(:last-child)]:mb-4'>
          {typeof message === 'string' ? <p>{message}</p> : message}
        </div>
        <div className='flex justify-end'>
          <Button label='Close' buttonType='primary-light' onClick={handleClose} />
        </div>
      </div>
    </div>
  )
}

export default Modal
